import { request, parseMessage } from '../../../utilities';

const executePayment = async context => {
  logger.info(`marshal - executePayment - context [${JSON.stringify(context)}]`);

  const { buffer = '', config = {} } = context || {};

  try {
    const response = await request({ buffer, config });

    const fields = parseMessage(response);

    logger.info(`marshal - executePayment - parsed message fields [${JSON.stringify(fields)}]`);

    const { responseCode = '', responseMessage = '' } = fields || {};

    if (responseCode !== '000' && responseCode !== '00') {
      throw new Error(responseMessage);
    }

    return { fields };
  } catch (err) {
    logger.error('marshal - executePayment - error:', err);
    throw err;
  }
};

export { executePayment };
